module.exports = __webpack_public_path__ + "img/image1.e50da3fe.png";